import { useContext, useState, useEffect, FormEvent } from 'react';
import FiltrosDefault from '../FiltrosDefault';
import NenhumResultadoEncontrado from '../NenhumResultadoEncontrato';
import LoadingBarra from '../LoadingBarra';
import avatarDefault from "../../assets/img/avatarDefault.png";
import DivSituacao from '../DivSituacao';
import { IoMdMenu } from "react-icons/io";
import { buscarDesafio, filtrarDesafio } from '../../services/desafios';
import "./index.css";
import { ModalEstadoContext } from '../../contexts/ModalEstado';
import { listaDesafios } from '../../interfaces/desafios';
import { toast } from 'react-toastify';
import ModalOpcoesDesafio from '../ModalOpcoesDesafio';
import Modal5w2h from '../Modal5w2h';
import ModalDesafio from '../ModalDesafio';
import MatrizPriorizacao from '../MatrizPriorizacao';
import maisFiltrosImg from '../../assets/img/maisFiltros.png'
import { membrosResponsaveis } from '../../interfaces/desafios';
import { Button, Loader } from '../Styles';
import { listarMembrosProjeto } from '../../services/projetos';
import { useLocation } from 'react-router-dom';

function Desafios() {
  const { modal, modalExibir, atualizarInformacoes } = useContext(ModalEstadoContext);

  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const usuarioExterno = localStorage.getItem("usuarioProjeto")

  const idProjeto = paramsUrl.get("idProjeto");
  const grupo = paramsUrl.get("grupo");

  const [processando, setProcessando] = useState(false);
  const [nenhumResultado, setNenhumResultado] = useState(false);
  const [desafios, setDesafios] = useState<listaDesafios[]>([]);
  const [titulo, setTitulo] = useState("");
  const [situacao, setSituacao] = useState("");
  const [desafioSelecionado, setDesafioSelecionado] = useState<listaDesafios>();
  const [maisFiltros, setMaisFiltros] = useState(false);
  const [responsaveis, setResponsaveis] = useState<membrosResponsaveis[]>([]);
  const [responsavel, setResponsavel] = useState("");

  const filtrarDesafios = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true);
    setMaisFiltros(false);
    try {
      if (!idProjeto) return toast.error("Projeto não encontrado.")

      const filtroPayload = {
        idResponsavel: responsavel,
        idProjeto,
        titulo: titulo,
        situacao,
      }
      const response = await filtrarDesafio(filtroPayload);
      if (response.status === 200 && response.data.length > 0) {
        setNenhumResultado(false);
        return setDesafios(response.data);
      }

      setDesafios(response.data)
      setNenhumResultado(true);

    } catch (error) {
      toast.error('Erro ao listar desafios:')
      setNenhumResultado(true);
    } finally {
      setProcessando(false);
    }
  };

  const abrirModalDesafio = (desafio: listaDesafios) => {
    modalExibir("ModalNovoDesafio")
    setDesafioSelecionado(desafio)
  }

  function ocultarModal() {
    setDesafioSelecionado(undefined)
    return modalExibir("")
  }

  useEffect(() => {
    const listarDesafios = async () => {
      setNenhumResultado(false);
      setProcessando(true);
      if (!idProjeto) return toast.error("Projeto não encontrado.")

      try {
        const response = await buscarDesafio(idProjeto);
        if (response.data && response.data.length > 0) {
          setDesafios(response.data);
        } else {
          setNenhumResultado(true);
        }
      } catch (error) {
        toast.error('Erro ao listar desafios.')
        setNenhumResultado(true);
      } finally {
        setProcessando(false);
      }
    };

    listarDesafios();
  }, [atualizarInformacoes, idProjeto]);

  useEffect(() => {
    const listarMembrosResponsaveis = async () => {
      if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")

      try {
        const idProjetoEncoded = encodeURIComponent(idProjeto)
        const resposta = await listarMembrosProjeto(idProjetoEncoded);
        if (resposta.status === 200) {
          return setResponsaveis(resposta.data)
        }
      } catch (error) {
        toast.error("Erro ao listar todos os membros do Projeto.");
      }
    };
    listarMembrosResponsaveis()

  }, [idProjeto])

  return (
    (grupo === "Gestão Financeira" || grupo === "Gestão de Pessoas" || grupo === "Outros") ? (
      <div id='paginaContainer'>
        {processando && <LoadingBarra />}
        <FiltrosDefault termo={titulo} situacao={situacao} placeholder='Pesquise pelo titulo do desafio' tipo={"Desafio"} onChangeTermo={(e) => { setTitulo(e.target.value) }} onChangeSituacao={(e) => { setSituacao(e.target.value) }} acaoBtn={() => { modalExibir("ModalNovoDesafio") }} listaSituacao={[{ nome: 'Todos', valor: '' }, { nome: 'Mapeando', valor: 'Mapeando' }, { nome: 'Estruturando', valor: 'Estruturando' }, { nome: 'Executando', valor: 'Executando' }, { nome: 'Superado', valor: 'Superado' }]} genero='masculino' isLoading={processando} maisFiltros={true} acaoMaisFiltro={() => { setMaisFiltros(true) }} onSubmit={filtrarDesafios} />
        {maisFiltros && <section id='maisOpcoesFiltrosTarefas'>
          <form id='maisOpcoesFiltrosTarefasContainer' onSubmit={filtrarDesafios}>
            <span id='filtrosContainerTitulo'>
              <img id='filtrosAvancadosTarefas' src={maisFiltrosImg} alt='' />
              <p>Filtros Avançados</p>
            </span>
            <section id='opcoesFiltrosTarefas'>
              <section>
                <span>
                  <label htmlFor="responsaveltarefa">Responsável</label>
                  <select id='responsaveltarefa' value={responsavel} onChange={(e) => setResponsavel(e.target.value)}>
                    <option value=""></option>
                    {responsaveis.map((responsavel) => (
                      <option key={responsavel.usuario.id} value={responsavel.usuario.id}>{responsavel.usuario.nome}</option>
                    ))}
                  </select>
                </span>
              </section>
            </section>

            <span id="botoesContainerFiltrosTarefas">
              <Button type='button' cor='cancelar' isLoading={processando} onClick={() => setMaisFiltros(false)}>Cancelar</Button>
              <Button type='submit' cor='salvar' isLoading={processando}>
                {!processando && 'Buscar Dados'}
                {processando && <Loader isLoading={processando} />}
              </Button>
            </span>
          </form>
        </section>}
        {nenhumResultado && <NenhumResultadoEncontrado />}
        <section id='fundoContainerPagina'>
          <table id='tabelaListaContainer'>
            <thead>
              <tr>
                <th align='left'>Titulo do Desafio</th>
                <th align='left' className='hide-responsive'>Responsável</th>
                <th className='progressoProcesso hide-responsive' align='center'>Progresso</th>
                <th className={usuarioExterno ? 'ladoDireitoContent': ''}>Situação</th>
                {!usuarioExterno && <th align='center'>Ações</th>}
              </tr>
            </thead>
            <tbody>
              {desafios.length > 0 && desafios.map((desafio) => {
                const total = desafio.planoAcaos?.length || 0;

                const concluidos = desafio.planoAcaos?.filter(acao => acao.situacao === "Finalizada").length || 0;
                const progresso = total > 0 ? (concluidos / total) * 100 : 0;

                return (
                  <tr key={desafio.id}>
                    <td className='primeiraColuna' onClick={() => { setDesafioSelecionado(desafio); abrirModalDesafio(desafio) }}>{desafio.titulo}</td>

                    <td align='left' className='hide-responsive usuarioResponsavelContentDesafios' onClick={() => { setDesafioSelecionado(desafio); abrirModalDesafio(desafio) }}>
                      <img src={desafio.usuario.avatar || avatarDefault} alt="" className="usuarioResponsavel" />
                      {desafio.usuario.nome}
                    </td>

                    <td id='progressoProcesso' className='hide-responsive' align='center' onClick={() => { setDesafioSelecionado(desafio); abrirModalDesafio(desafio) }}>
                      <svg width={100} height={20} rx={5} ry={5}>
                        <rect rx={5} ry={5} width={100} height={20} stroke='rgba(106, 108, 114, 0.2)' strokeWidth={2} fill='none' />
                        <rect rx={5} ry={5} width={progresso} height={20} fill='#25ae88' />
                      </svg>
                    </td>

                    <td align='center' className={usuarioExterno ? 'ladoDireitoContent': ''} onClick={() => { setDesafioSelecionado(desafio); abrirModalDesafio(desafio) }}>
                      <DivSituacao texto={desafio.situacao} cor={desafio.situacao.toLocaleLowerCase()} />
                    </td>

                    {!usuarioExterno && <td align='center' className='ladoDireitoContent' onClick={() => { setDesafioSelecionado(desafio); modalExibir("ModalOpcoesDesafios") }}>
                      <IoMdMenu className='icone-lista' />
                    </td>}
                  </tr>
                )
              })}
            </tbody>
          </table>
        </section>

        {modal.nome === "ModalOpcoesDesafios" && <ModalOpcoesDesafio />}
        {modal.nome === "Modal5w2h" && <Modal5w2h desafio={desafioSelecionado} setDesafio={setDesafioSelecionado} />}
        {modal.nome === "ModalMatrizPriorizacao" && desafioSelecionado && <MatrizPriorizacao desafio={desafioSelecionado} />}
        {modal.nome === "ModalNovoDesafio" && <ModalDesafio desafio={desafioSelecionado} onClose={ocultarModal} />}
      </div>
    ) : null
  );
}

export default Desafios;
